import { CircularProgress, Grid } from '@mui/material';
import { useQuery } from '@apollo/client/react';
import { GET_USER_OCCUPATION } from './reports.graphql';
import { UserModel } from '../interfaces';
import { GeneralExcelExport, GeneralExcelExportProps } from './brreg';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { nbNO } from '@mui/x-data-grid/locales';

export function UserOccupation() {
  const { loading, data } = useQuery<{ userOccupation: UserModel[] }>(GET_USER_OCCUPATION);
  if (loading || !data) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }
  const groupedData = groupByOccupation(data.userOccupation);
  const sortedData = groupedData.sort((a, b) => a.occupation.localeCompare(b.occupation));

  const arrHeading: string[] = ['Yrke', 'Antall bruker'];
  const dataSet = sortedData && sortedData.map((x) => [x.occupation, x.count]);
  const workBook = 'BRUKER_ANTALL_PER_YRKE';
  const fileName = 'brukerantall.xlsx';
  const props: GeneralExcelExportProps = {
    dataSet: JSON.stringify(dataSet),
    headings: JSON.stringify(arrHeading),
    workBookName: workBook,
    fileName: fileName,
  };

  const rows = sortedData.map((x) => ({
    id: x.occupation,
    occupation: x.occupation,
    count: x.count,
  }));

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      field: 'occupation',
      headerName: 'Yrke',
      minWidth: 160,
      flex: 1,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'count',
      headerName: 'Antall brukere',
      minWidth: 160,
      flex: 1,
      align: 'left',
      headerAlign: 'left',
      type: 'number',
    },
  ];

  return (
    <Grid container>
      <Grid>
        {sortedData && <GeneralExcelExport {...props} />}
        <DataGridPro
          autoHeight
          density="compact"
          rows={rows}
          columns={columns}
          localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
          pagination
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
                page: 0,
              },
            },
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 700,
            },
          }}
        />
      </Grid>
    </Grid>
  );
}
function groupByOccupation(data: UserModel[]) {
  const groupedData = data.reduce(
    (groups, user) => {
      const { occupation } = user;
      if (!groups[occupation]) {
        groups[occupation] = {
          occupation,
          count: 0,
        };
      }
      groups[occupation].count++;
      return groups;
    },
    {} as Record<string, { occupation: string; count: number }>,
  );
  return Object.values(groupedData);
}
